<script lang="ts">
  import Layout from './lib/components/Layout.svelte';
  import Hero from './sections/Hero.svelte';
  import Introduction from './sections/Introduction.svelte';
  import RubiksCliff from './sections/RubiksCliff.svelte';
  import RubiksCube from './sections/RubiksCube.svelte';
  import Conclusion from './sections/Conclusion.svelte';
  import Reliability from './sections/Reliability.svelte';
  import Consistency from './sections/Consistency.svelte';
  import CapabilityCurves from './sections/CapabilityCurves.svelte';
  import ThinkingOps from './sections/ThinkingOps.svelte';
  import GrindVsQuit from './sections/GrindVsQuit.svelte';
</script>

<Layout>
  <Hero />
  <RubiksCliff />
  <Introduction />
  <Reliability />
  <Consistency />
  <ThinkingOps />
  <GrindVsQuit />
  <CapabilityCurves />
  <RubiksCube />
  <Conclusion />
</Layout>
